/**
 * UBL Hook for Size Compare Button
 *
 * @description 사이즈 비교하기 버튼 UBL 로깅
 */
import { useUBL, useUBLContext } from '@common/log-manager';

export const useSizeCompareBtnUBL = () => {
  const sendUBL = useUBL();
  const ublContext = useUBLContext();

  const navigation = ublContext.navigation || 'product_detail';

  // ============ impression ============

  /**
   * 사이즈 비교하기 버튼 노출
   */
  const sizeCompareBtnImpressionUBL = () => {
    sendUBL({
      category: 'impression',
      navigation,
      navigation_sub: ublContext.navigation_sub,
      object_section: 'size_compare_btn',
      object_type: 'button',
      object_id: 'size_compare_btn',
      data: ublContext.data,
    });
  };

  // ============ click ============

  /**
   * 사이즈 비교하기 버튼 클릭
   */
  const sizeCompareBtnClickUBL = () => {
    sendUBL({
      category: 'click',
      navigation,
      navigation_sub: ublContext.navigation_sub,
      object_section: 'size_compare_btn',
      object_type: 'button',
      object_id: 'size_compare_btn',
      data: ublContext.data,
    });
  };

  return {
    // impression
    sizeCompareBtnImpressionUBL,
    // click
    sizeCompareBtnClickUBL,
  };
};
